import serviceHelper from './serviceHelper';

export default {
    methods: {
        initCreateOrder(serviceId, orderList, linkParams = {}) {
            let lastOrder = null;

            for (let orderElem in orderList) {
                let order = orderList[orderElem];

                if (order.status !== 3 && order.sid === serviceId) {
                    if (order.created && (!lastOrder || new Date(order.created.replace(' ', 'T')) > new Date(lastOrder.created.replace(' ', 'T')))) {
                        lastOrder = order;
                    }
                }
            }

            let url = serviceHelper.methods.serviceIdToLink(serviceId);
            const searchParams = new URLSearchParams(linkParams).toString();
            const searchParamsString = searchParams ? '?' + searchParams : '';

            if (lastOrder) {
                const orderCreated = new Date(lastOrder.created.replace(' ', 'T'));
                const currentDate = new Date();

                if (orderCreated.getFullYear() !== currentDate.getFullYear()) {
                    url += searchParamsString + '#auto-create-order';
                } else {
                    url += '/' + lastOrder.id + searchParamsString;
                }
            } else {
                url += searchParamsString + '#auto-create-order';
            }

            location = url;
        }
    }
}
